import {createFileRoute} from '@tanstack/react-router'
import {Alert, Button, Container, Group, Tabs, Title} from "@mantine/core"
import {DateInput} from "@mantine/dates";
import {IconAlertHexagon, IconCheck, IconInfoCircle, IconX} from "@tabler/icons-react";
import {useState} from "react";
import {format, isAfter, isSameDay, parse} from "date-fns";
import {cs} from "date-fns/locale";
import {useDateDailyMenu} from "@state/server/dailyMenu.query.ts";
import DailyMenu from "@components/dailyMenu.tsx";

export const Route = createFileRoute('/_authenticated/_dailymenu/dailymenu/day')({
	component: RouteComponent,
})
const emptyFormatString = "nevybráno";

function RouteComponent() {
	const [selectedDay, setSelectedDay] = useState<Date | null>(null)
	const [selectedFormat, setSelectFormat] = useState<string>(emptyFormatString)
	const [queryDate, setQueryDate] = useState<Date | null>(null)
	const {data, isLoading, isError, error} = useDateDailyMenu(queryDate, queryDate != null)
	const isOld = data ? !isSameDay(new Date(), parse(data.day ?? "", "yyyy-MM-dd", new Date())) && isAfter(new Date(), parse(data.day ?? "", "yyyy-MM-dd", new Date())): false;

	const onUpdateSelection = () => {
		if (selectedDay != null) {
			const formatedDate = format(selectedDay, "EEEE, do MMMM yyyy", {locale: cs})
			setQueryDate(selectedDay)
			setSelectFormat(formatedDate)
		} else {
			setSelectFormat(emptyFormatString)
			setSelectedDay(null)
		}
	}

	const clearSelection = () => {
		setSelectedDay(null);
		setSelectFormat(emptyFormatString)
		setQueryDate(null)
	}

	return (
		<Tabs.Panel value={"day"}>
			<Container fluid>
				<Title order={2} py={"md"}>Nabídka pro den ({selectedFormat})</Title>
				<Group>
					<DateInput valueFormat={"DD. MM. YYYY"} value={selectedDay} onChange={setSelectedDay}/>
					<Button leftSection={<IconCheck/>} onClick={onUpdateSelection}>Zvolit</Button>
					<Button leftSection={<IconX/>} onClick={clearSelection}>Vymazat</Button>
				</Group>
				{(queryDate && isLoading) && <p>Loading...</p>}
				{(queryDate && data && isOld) &&
					<Alert variant={"light"} color={"blue"} title={"Info"} icon={<IconInfoCircle/>} my={"md"}>
                        Staré nabídky již není možné upravovat
                    </Alert>
				}
				{(queryDate && data) && <DailyMenu dailyMenu={data} disableEditing={isOld}/>}
				{/*@ts-expect-error it does, but typing is weird*/}
				{(queryDate && isError && error.status == 404) &&
                    <Alert variant={"light"} title={"Chyba"} icon={<IconAlertHexagon/>} my={"md"}>
                        Na tento den nabídka neexistuje
                    </Alert>
				}
			</Container>
		</Tabs.Panel>
	)
}
